import { render, staticRenderFns } from "./page-pull-requests.vue?vue&type=template&id=2002e9aa&scoped=true"
import script from "./page-pull-requests.vue?vue&type=script&lang=js"
export * from "./page-pull-requests.vue?vue&type=script&lang=js"
import style0 from "./page-pull-requests.vue?vue&type=style&index=0&id=2002e9aa&prod&scoped=true&lang=css"
import style1 from "./page-pull-requests.vue?vue&type=style&index=1&id=2002e9aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2002e9aa",
  null
  
)

export default component.exports